import { createAction, props } from "@ngrx/store";

enum ERoundHistoryActions {
    AddRounds = "Add Rounds",
    ClearRounds = "Clear Rounds"
}

export const addHistoryRounds = createAction(ERoundHistoryActions.AddRounds, props<{ roundCoefficients: number[] }>());
export const clearHistoryRounds = createAction(ERoundHistoryActions.ClearRounds);
